import { WsBaseRequest } from 'api/ws/WsRequest';
import { API_GET_TOURNAMENT_LEADERBOARDS } from 'api/notificationManager/methods';

export default class GetTournamentLeaderboardsRequest extends WsBaseRequest {
  constructor(tournamentID: number, page: number) {
    super(API_GET_TOURNAMENT_LEADERBOARDS, { id: tournamentID, p: page });
  }
}
